import { createSelector } from 'reselect'
import { capitalize, upperFirst } from 'lodash'
import { RootState } from '../types'
import { LoadingStateEnum } from '../../types'

export const getAuditLogsLoadingState = (state: RootState): RootState['auditLogs']['logs']['loading'] =>
  state.auditLogs.logs.loading

export const auditLogsLoading = createSelector(
  getAuditLogsLoadingState,
  (state): boolean => state === LoadingStateEnum.LOADING,
)

export const getAuditLogsData = (state: RootState): RootState['auditLogs']['logs']['data'] => state.auditLogs.logs.data
export const getAuditLogsError = (state: RootState): RootState['auditLogs']['logs']['error'] =>
  state.auditLogs.logs.error

export const getLogTypesLoadingState = (state: RootState): RootState['auditLogs']['types']['loading'] =>
  state.auditLogs.types.loading

export const logTypesLoading = createSelector(
  getLogTypesLoadingState,
  (state): boolean => state === LoadingStateEnum.LOADING,
)

export const getLogTypesData = createSelector(
  (state: RootState): RootState['auditLogs']['types']['data'] => state.auditLogs.types.data,
  (types) =>
    types.map((type) => ({
      label: upperFirst(type),
      value: capitalize(type),
    })),
)
export const getLogTypesError = (state: RootState): RootState['auditLogs']['types']['error'] =>
  state.auditLogs.types.error
